import React, {useState} from "react";

/**
 * @typedef {StackTraceListPartial} SingleStackTraceLine
 @property {String} classLoaderName
 @property {String} className
 @property {String} fileName
 @property {String} methodName
 @property {int} lineNumber
 @property {boolean} nativeMethod
 */

/**
 * @typedef {StackTraceList} StackTraceList
 @property {StackTraceListPartial []} singleStackTraceLine
 */

/**
 * @typedef {Object} ErrorTeaserModel
 * @property {String} originTeaserType
 * @property {String} internalName
 * @property {String} errorMessage
 * @property {String} linkUrl
 * @property {'ERROR_TEASER'} type
 * @property {Throwable} exception
 * @property {StackTraceList[]} stackTraceList
 * @property {StackTraceList[]} causeStackTraceList
 * @property {boolean} hasStacktraces
 */

/**
 * @param {ErrorTeaserModel} model
 * @returns {JSX.Element}
 */
export function ErrorTeaser({model}) {
    const [showStackTrace, setShowStackTrace] = useState(false);
    const lines = model.errorMessage ? model.errorMessage.split('\n') : null;
    const errorMessage = lines ?
        <>
            {lines.map((line, index) => (
                <React.Fragment key={index}>
                    {line}
                    <br/>
                </React.Fragment>)
            )}
        </>
        :
        <></>

    return (
        <div className="content-platform__teaser content-platform__teaser--error">
            <div className="content-platform__teaser--text content-platform__error-sign">
                {model.linkUrl ?
                    <a href={model.linkUrl}>
                        <div className='content-platform__teaser__container' style={{whiteSpace: "pre-wrap"}}>
                            Error processing element of type
                            <strong>{model.originTeaserType}</strong>
                            with Internal Name: "{model.internalName}".
                            {model.errorMessage &&
                                <>
                                    <p>Reason: </p>
                                    {errorMessage}
                                </>
                            }
                        </div>
                    </a>
                    :
                    <div className="content-platform__teaser__container" style={{whiteSpace: "pre-wrap"}}>
                        <p>Error: </p>
                        {errorMessage}
                    </div>
                }

                {model.hasStacktraces &&
                    <>
                        {!showStackTrace &&
                            <button onClick={() => setShowStackTrace(showStackTrace => !showStackTrace)}>
                                Show Stacktrace
                            </button>}
                        {showStackTrace &&
                            <>
                                {model.stackTraceList &&
                                    <StackTraceListPartial stackTraceList={model.stackTraceList} title="Stacktrace"/>}

                                {model.causeStackTraceList &&
                                    <StackTraceListPartial stackTraceList={model.causeStackTraceList}
                                                           title="Cause Stacktrace"/>}
                            </>}
                    </>
                }
            </div>
        </div>
    )
}

function StackTraceListPartial({stackTraceList, title}) {
    const [showMore, setShowMore] = useState(false);
    const elementsToShow = showMore ? stackTraceList : stackTraceList.slice(0, 1)
    return <div>
        <p>{title}:</p>
        {elementsToShow.map(list =>
            <>
                < ul>
                    {list.map(entry =>
                        <li>{entry.className}.{entry.methodName}:{entry.lineNumber}</li>
                    )}
                </ul>
                {!showMore &&
                    <button onClick={() => setShowMore(showMore => !showMore)}>
                        show more
                    </button>
                }
            </>
        )
        }
    </div>
}
